import { openDialog } from "vue3-promise-dialog";
import TransferConversationModal, {
  TransferChannelOption,
} from "@/components/modals/TransferConversationModal.vue";
import TransferConversationDestinationModal from "@/components/modals/TransferConversationDestinationModal.vue";

export async function showTransferConversationDialog() {
  return await openDialog(TransferConversationModal);
}

export async function showTransferConversationDestinationDialog(
  data: TransferChannelOption,
  backAction:
    | "none"
    | "transfer-conversation-modal" = "transfer-conversation-modal"
) {
  return await openDialog(TransferConversationDestinationModal, {
    backAction,
    data,
  });
}
